import { render, staticRenderFns } from "./team-events.vue?vue&type=template&id=11f01221&"
import script from "./team-events.vue?vue&type=script&lang=js&"
export * from "./team-events.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports